(function () {
    'use strict';

    angular
        .module('core.filters')
        .filter('formatPhone', FormatPhone)
        .filter('formatPhoneComplete', FormatPhoneComplete)

    function FormatPhone() {
        return input => {
            let str = input + '';
            str = str.replace(/\D/g, '');

            if (str.length === 9)
                str = str.replace(/^(\d{5})(\d{4})/, '$1-$2');
            else
                str = str.replace(/^(\d{4})(\d{4})/, '$1-$2');

            return str;
        }
    }

    function FormatPhoneComplete() {
        return input => {
            let str = input + '';
            str = str.replace(/\D/g, '');

            if (str.length === 11)
                str = str.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
            else
                str = str.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

            return str;
        }
    }
}());